module.exports = __webpack_public_path__ + "media/images/emblems/Granges-coat_of_arms-db3b7175a50e8220bc3e1fef4b9fd875.svg";